import {tgxApi} from "../../../app/tgxApi";
import {
    getAuthorizationHeader, getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../../helpers/utils/RtkQueryUtils";
import {getFileName, serialize} from "../../../helpers/utils/Utils";
import {downloadFile} from "../../../helpers/utils/FileUtils";

export const statesApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        getAllStates: build.query({
            query: () => {
                return {
                    url: `/ajax/get-all-states`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        searchStates: build.query({
            query: (query) => {
                return {
                    url: `/ajax/states/paged?${serialize(query)}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ["states"],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        createState: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/submitState`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['states'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "State");
            },
        }),
        getStateById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-state-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['stateById'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        updateState: build.mutation({
            query: ({id, requestBody}) => {
                return {
                    url: `/ajax/update-state-by-id/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['states', 'stateById','userAuditableInfo'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "State");
            },
        }),

        exportStateData: build.query({
            query: (query) => {
                return {
                    url: `/export/state`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("states"))
                        return {success: true};
                    },
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

    }),
});


export const {
    useGetAllStatesQuery,
    useSearchStatesQuery,
    useCreateStateMutation,
    useUpdateStateMutation,
    useGetStateByIdQuery,
    useLazyExportStateDataQuery,
    useLazyGetAllStatesQuery
} = statesApi;